// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  productRequest: ['data'],
  productSuccess: ['data'],
  productFailure: ['err'],

  getProductCustomRequest: ['data'],
  getProductCustomSuccess: ['data'],
  getProductCustomFailure: ['err'],

  productCreateRequest: ['data'],
  productCreateSuccess: ['data'],
  productCreateFailure: ['err'],

  productDeleteRequest: ['data'],
  productDeleteSuccess: ['data'],
  productDeleteFailure: ['err'],

  productUpdateRequest: ['data'],
  productUpdateSuccess: ['data'],
  productUpdateFailure: ['err'],

  getProductCountryRequest: ['data'],
  getProductCountrySuccess: ['data'],
  getProductCountryFailure: ['err'],

  postProductCountryRequest: ['data'],
  postProductCountrySuccess: ['data'],
  postProductCountryFailure: ['err'],

  deleteProductCountryRequest: ['data'],
  deleteProductCountrySuccess: ['data'],
  deleteProductCountryFailure: ['err'],

  getProductCampaignRequest: ['data'],
  getProductCampaignSuccess: ['data'],
  getProductCampaignFailure: ['err'],

  postProductCampaignRequest: ['data'],
  postProductCampaignSuccess: ['data'],
  postProductCampaignFailure: ['err'],

  putProductCampaignRequest: ['data'],
  putProductCampaignSuccess: ['data'],
  putProductCampaignFailure: ['err'],

  deleteProductCampaignRequest: ['data'],
  deleteProductCampaignSuccess: ['data'],
  deleteProductCampaignFailure: ['err'],

  getProductVariantRequest: ['data'],
  getProductVariantSuccess: ['data'],
  getProductVariantFailure: ['err'],

  postProductVariantRequest: ['data'],
  postProductVariantSuccess: ['data'],
  postProductVariantFailure: ['err'],

  putProductVariantRequest: ['data'],
  putProductVariantSuccess: ['data'],
  putProductVariantFailure: ['err'],

  deleteProductVariantRequest: ['data'],
  deleteProductVariantSuccess: ['data'],
  deleteProductVariantFailure: ['err'],

  getProductVariantItemRequest: ['data'],
  getProductVariantItemSuccess: ['data'],
  getProductVariantItemFailure: ['err'],

  postProductVariantItemRequest: ['data'],
  postProductVariantItemSuccess: ['data'],
  postProductVariantItemFailure: ['err'],

  deleteProductVariantItemRequest: ['data'],
  deleteProductVariantItemSuccess: ['data'],
  deleteProductVariantItemFailure: ['err']
})

export const ProductTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: null,
  custom: [],
  campaign: [],
  variant: [],
  variant_item: [],
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) => state.merge({ fetching: true, err: null, success: null })

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null
  })

export const successCustom = (state: Object, { data }: Object) =>
state.merge({
  fetching: false,
  custom: data,
  err: null
})

export const successCampaign = (state: Object, { data }: Object) =>
state.merge({
  fetching: false,
  campaign: data,
  err: null
})

export const successVariant = (state: Object, { data }: Object) =>
state.merge({
  fetching: false,
  variant: data,
  err: null
})

export const successVariantItem = (state: Object, { data }: Object) =>
state.merge({
  fetching: false,
  variant_item: data,
  err: null
})

export const successCountry = (state: Object, { data }: Object) =>
state.merge({
  fetching: false,
  country: data,
  err: null
})

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null, err: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) => state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(
  INITIAL_STATE,
  {
    [Types.PRODUCT_SUCCESS]: success,
    [Types.PRODUCT_REQUEST]: request,
    [Types.PRODUCT_FAILURE]: failure,

    [Types.GET_PRODUCT_CUSTOM_SUCCESS]: successCustom,
    [Types.GET_PRODUCT_CUSTOM_REQUEST]: request,
    [Types.GET_PRODUCT_CUSTOM_FAILURE]: failure,

    [Types.PRODUCT_CREATE_SUCCESS]: manipulateSuccess,
    [Types.PRODUCT_CREATE_REQUEST]: manipulateRequest,
    [Types.PRODUCT_CREATE_FAILURE]: manipulateFailure,

    [Types.PRODUCT_DELETE_SUCCESS]: manipulateSuccess,
    [Types.PRODUCT_DELETE_REQUEST]: manipulateRequest,
    [Types.PRODUCT_DELETE_FAILURE]: manipulateFailure,

    [Types.PRODUCT_UPDATE_SUCCESS]: manipulateSuccess,
    [Types.PRODUCT_UPDATE_REQUEST]: manipulateRequest,
    [Types.PRODUCT_UPDATE_FAILURE]: manipulateFailure,

    [Types.GET_PRODUCT_COUNTRY_SUCCESS]: successCountry,
    [Types.GET_PRODUCT_COUNTRY_REQUEST]: request,
    [Types.GET_PRODUCT_COUNTRY_FAILURE]: failure,

    [Types.POST_PRODUCT_COUNTRY_SUCCESS]: manipulateSuccess,
    [Types.POST_PRODUCT_COUNTRY_REQUEST]: manipulateRequest,
    [Types.POST_PRODUCT_COUNTRY_FAILURE]: manipulateFailure,

    [Types.DELETE_PRODUCT_COUNTRY_SUCCESS]: manipulateSuccess,
    [Types.DELETE_PRODUCT_COUNTRY_REQUEST]: manipulateRequest,
    [Types.DELETE_PRODUCT_COUNTRY_FAILURE]: manipulateFailure,

    [Types.GET_PRODUCT_CAMPAIGN_SUCCESS]: successCampaign,
    [Types.GET_PRODUCT_CAMPAIGN_REQUEST]: request,
    [Types.GET_PRODUCT_CAMPAIGN_FAILURE]: failure,

    [Types.POST_PRODUCT_CAMPAIGN_SUCCESS]: manipulateSuccess,
    [Types.POST_PRODUCT_CAMPAIGN_REQUEST]: manipulateRequest,
    [Types.POST_PRODUCT_CAMPAIGN_FAILURE]: manipulateFailure,

    [Types.PUT_PRODUCT_CAMPAIGN_SUCCESS]: manipulateSuccess,
    [Types.PUT_PRODUCT_CAMPAIGN_REQUEST]: manipulateRequest,
    [Types.PUT_PRODUCT_CAMPAIGN_FAILURE]: manipulateFailure,

    [Types.DELETE_PRODUCT_CAMPAIGN_SUCCESS]: manipulateSuccess,
    [Types.DELETE_PRODUCT_CAMPAIGN_REQUEST]: manipulateRequest,
    [Types.DELETE_PRODUCT_CAMPAIGN_FAILURE]: manipulateFailure,

    [Types.GET_PRODUCT_VARIANT_SUCCESS]: successVariant,
    [Types.GET_PRODUCT_VARIANT_REQUEST]: request,
    [Types.GET_PRODUCT_VARIANT_FAILURE]: failure,

    [Types.POST_PRODUCT_VARIANT_SUCCESS]: manipulateSuccess,
    [Types.POST_PRODUCT_VARIANT_REQUEST]: manipulateRequest,
    [Types.POST_PRODUCT_VARIANT_FAILURE]: manipulateFailure,

    [Types.PUT_PRODUCT_VARIANT_SUCCESS]: manipulateSuccess,
    [Types.PUT_PRODUCT_VARIANT_REQUEST]: manipulateRequest,
    [Types.PUT_PRODUCT_VARIANT_FAILURE]: manipulateFailure,

    [Types.DELETE_PRODUCT_VARIANT_SUCCESS]: manipulateSuccess,
    [Types.DELETE_PRODUCT_VARIANT_REQUEST]: manipulateRequest,
    [Types.DELETE_PRODUCT_VARIANT_FAILURE]: manipulateFailure,

    [Types.GET_PRODUCT_VARIANT_ITEM_SUCCESS]: successVariantItem,
    [Types.GET_PRODUCT_VARIANT_ITEM_REQUEST]: request,
    [Types.GET_PRODUCT_VARIANT_ITEM_FAILURE]: failure,

    [Types.POST_PRODUCT_VARIANT_ITEM_SUCCESS]: manipulateSuccess,
    [Types.POST_PRODUCT_VARIANT_ITEM_REQUEST]: manipulateRequest,
    [Types.POST_PRODUCT_VARIANT_ITEM_FAILURE]: manipulateFailure,

    [Types.DELETE_PRODUCT_VARIANT_ITEM_SUCCESS]: manipulateSuccess,
    [Types.DELETE_PRODUCT_VARIANT_ITEM_REQUEST]: manipulateRequest,
    [Types.DELETE_PRODUCT_VARIANT_ITEM_FAILURE]: manipulateFailure
  }
)



// WEBPACK FOOTER //
// ./src/Redux/ProductRedux.js